// @flow strict

export const en = {
  _blog_title: 'All posts',
  _blog_description:
    'Latest customer service news and tips on automation, chatbots, self-service and much more.',
  _blog_read_more: 'Read more',

  _blog_intro_headline: 'Hello there.',
  _blog_intro_text:
    'Latest customer service news and tips on automation, chatbots, self-service and much more.',

  _blog_all_intro_headline: 'Hello there.',
  _blog_all_intro_text:
    'Latest customer service news and tips on automation, chatbots, self-service and much more.',

  _about_us_teaser: 'About us',
  _about_us_headline: 'We love customer service',
  _about_us_text:
    'For 10 years we have been pioneers in the field of customer service automation and artificial intelligence. In the last years we have gained so much expert knowledge and experience with our customers that we would like to share this knowledge with you here.',
  _about_us_see_more_posts: 'See more posts',
  _about_us_see_all: 'See all',

  _author_no_author: 'No author',
  _author_time_to_read: 'min read',
  _author_updated: 'Updated',
  _author_read_all: 'Read all articles',
  _author_latest_posts: 'Latest posts by',

  _authors_title: 'Authors',
  _authors_description:
    'The OMQ authoring team is a diverse team that writes about topics such as customer service, artificial intelligence, automation and NLP technology.',

  _menu_magazine: 'Magazine',
  _menu_products: 'Products',
  _menu_company: 'Company',
  _menu_about_us: 'About us',
  _menu_jobs: 'Jobs',
  _menu_imprint: 'Imprint',
  _menu_privacy_policy: 'Privacy policy',
  _menu_contact: 'Contact',

  _navigation_cta_button: 'Test now',

  _helping_hands_see_more: 'See more',

  _newsletter_title: 'Magazine Newsletter',
  _newsletter_description:
    'Always the latest tips and tutorials to improve and optimize your customer service.',
  _newsletter_input: 'Enter your email',
  _newsletter_submit: 'Sign up for our Newsletter',
  _newsletter_private_policy:
    'I have read and understand <a href="/company/data-security/" title="OMQ Data privacy policy">OMQ\'s</a> privacy policy.',
  _newsletter_missing_privacy_check:
    'Please confirm that you have read the privacy policy.',

  _search_title: 'Search',
  _search_description:
    'Here you can search for articles on topics like customer service automation, chatbots, self service, artificial intelligence or NLP.',
  _search_field_placeholder: 'Search the magazine...',
  _search_result: 'Showing results for: ',
  _search_most_popular_tags: 'Most popular tags',
  _search_articles_by_category: 'Articles by category',
  _search_menu_item: 'Search the blog',

  _names_products_contact: 'Smart Contact Form',
  _names_products_help: 'Intelligent Help Page',
  _names_products_assist: 'Ticket System Assistant',
  _names_products_reply: 'AI Email Bot',
  _names_products_chatbot: 'AI-Chatbot',
  _names_products_ai_agents: 'AI Agent',

  _links_products_contact: '/products/contact/',
  _links_products_help: '/products/help/',
  _links_products_assist: '/products/assist/',
  _links_products_reply: '/products/reply/',
  _links_products_chatbot: '/products/chatbot/',
  _links_products_ai_agents: '/products/ai-agent/',

  _links_company_about_us: '/company/about-us/',
  _links_company_jobs: '/company/jobs/',
  _links_company_imprint: '/company/imprint/',
  _links_company_data_privacy: '/company/data-security/',
  _links_company_contact: '/company/contact/',

  _links_navigation_cta_button: '/landing-pages/create-account/',

  _video_fallback:
    'Dieser Browser unterstützt leider keine Videos. Du kannst das Video hier ansehen.',

  _audio_fallback:
    'Dieser Browser unterstützt leider dieses Audio Format nicht. Du kannst die Datei hier herunterladen.',

  _cookie_consent_settings: 'Cookie settings',
  _cookie_consent_text:
    'We use cookies to collect and analyse information on site performance and usage, to provide social media features and to enhance and customise content and advertisements.',
  _cookie_consent_link: 'https://omq.ai/company/data-security/',
  _cookie_consent_link_text: 'Learn more',
  _cookie_consent_button_all_text: 'Allow all cookies',
  _cookie_consent_button_function_text: 'Only functional',

  _top_banner_button_mobile: 'Subscribe',
  _top_banner_button_desktop: 'Subscribe to our newsletter',

  _glossary_title: 'Lexicon',
  _glossary_description:
    'Interesting facts about chatbots, artificial intelligence and conversational AI. From A to Z.',
  _glossary_intro_image_alt: 'Women with a smartphone in her hand',
  _glossary_intro_headline: 'Chatbot Lexicon',
  _glossary_intro_text:
    'Interesting facts about chatbots, artificial intelligence and conversational AI. From A to Z.',
  _glossary_clear_filter: 'Clear filter',
  _glossary_all_articles: 'All articles',
  _glossary_back_to: 'Back to the lexicon',
};
